import { UnstyledButton } from '@mantine/core';
import { BuildingEstate } from 'tabler-icons-react';

import { getNameLocal } from '../../../lib/local/get-title';
import { useLocal } from '../../../lib/local/use-local';

import styles from './options-list.module.css';

type NameLangs = {
  nameRu: string | null;
  nameEn: string | null;
  nameHy: string | null;
};

const ListItem = ({
  value,
  label,
  onClick,
}: {
  value: string;
  label: NameLangs;
  onClick?: (item: { value: string; label: NameLangs }) => void;
}) => {
  const [lang] = useLocal();
  const handleOnClick = () => {
    onClick && onClick({ value, label });
  };

  return (
    <li role="option" className={styles.listItem}>
      <UnstyledButton className={styles.listItemButton} onClick={handleOnClick}>
        <BuildingEstate
          size={32}
          strokeWidth={1}
          color={'black'}
          className={styles.listItemIcon}
        />
        {getNameLocal(lang, label)}
      </UnstyledButton>
    </li>
  );
};

export const OptionsList = ({
  data,
  onSelect,
}: {
  data: { value: string; label: NameLangs }[];
  onSelect?: (item: { value: string; label: NameLangs }) => void;
}) => {
  return (
    <ul role="listbox" className={styles.listbox}>
      {data.map((itemData) => (
        <ListItem key={itemData.value} {...itemData} onClick={onSelect} />
      ))}
    </ul>
  );
};
